// extracted by css-extract-rspack-plugin
export default {"CardBaseWithSash":"index-module__CardBaseWithSash__A3iizi6","dragDisabled":"index-module__dragDisabled__TJurz5T","isRedacted":"index-module__isRedacted__IZONiDV"};